import { z } from 'zod'
import { http } from './http'
import type { ApiEnvelope } from '../types/api'

const loginResponseSchema = z.object({
  accessToken: z.string().min(1),
  refreshToken: z.string().min(1),
  expiresIn: z.number().positive(),
  administrator: z.object({
    id: z.string(),
    username: z.string(),
    displayName: z.string(),
  }),
})

export type LoginResponse = z.infer<typeof loginResponseSchema>

export interface LoginRequest {
  username: string
  password: string
}

export const adminAuthApi = {
  async login(payload: LoginRequest): Promise<LoginResponse> {
    const response = await http.post<ApiEnvelope<unknown>>('/admin/auth/login', payload)
    return loginResponseSchema.parse(response.data.data)
  },
}
